import { None, Some, type Option } from "@bodil/opt";

/**
 * Iterate until calling `mapFn` on an item returns a value, then return
 * that value. Return `undefined` if `mapFn` never returns a value.
 */
export function findMap<T, U>(
    iter: Iterator<T, undefined>,
    mapFn: (value: T, index: number) => NonNullable<U> | undefined,
): NonNullable<U> | undefined {
    let index = 0;
    while (true) {
        const result = iter.next();
        if (result.done === true) {
            return undefined;
        }
        const mapped = mapFn(result.value, index++);
        if (mapped !== undefined) {
            return mapped;
        }
    }
}

/**
 * Get the next value from the iterator, wrapped in an {@link Option}
 * type. If the iterator has no more values, return {@link None}.
 */
export function takeOne<T>(it: Iterator<T>): Option<T> {
    const result = it.next();
    return result.done === true ? None : Some(result.value);
}

export function numberShort(value: number | null | undefined): string {
    if (typeof value !== "number") {
        value = 0;
    }
    return new Intl.NumberFormat(undefined, {
        maximumFractionDigits: 1,
    }).format(value);
}

export function formatList(
    items: Array<string> | undefined,
    type: Intl.ListFormatOptions["type"] = "unit",
    style: Intl.ListFormatOptions["style"] = "short",
): string {
    return items === undefined ? "" : new Intl.ListFormat(undefined, { type, style }).format(items);
}
